export default __webpack_public_path__ + "static/media/cake_stand.63324500.svg";